import { render, staticRenderFns } from "./SetMoneyWarning.vue?vue&type=template&id=fb399cf2"
import script from "./SetMoneyWarning.vue?vue&type=script&lang=js"
export * from "./SetMoneyWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports